'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _dropDownMenu = require('common/components/drop-down-menu');

var _dropDownMenu2 = _interopRequireDefault(_dropDownMenu);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _setTimeout = require('common/utils/set-timeout');

var _setTimeout2 = _interopRequireDefault(_setTimeout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TopBarMenuLink = _react2['default'].createClass({
    displayName: 'TopBarMenuLink',


    propTypes: {
        'linkText': _react2['default'].PropTypes.string.isRequired,
        'linkUrl': _react2['default'].PropTypes.string,
        'linkOptions': _react2['default'].PropTypes.object,
        'linkOverrideColors': _react2['default'].PropTypes.object,
        'pageToHighLight': _react2['default'].PropTypes.string,
        'useWhite': _react2['default'].PropTypes.bool
    },

    componentDidMount: function componentDidMount() {
        if (this.state.menuLeft == null) {
            // Only set once
            this.getMenuLeft();
        }
    },

    // dropdown menu-related functions
    getInitialState: function getInitialState() {
        return {
            'menuOpen': false,
            'menuLeft': null
        };
    },

    getMenuLeft: function getMenuLeft() {
        var node = _reactDom2['default'].findDOMNode(this);
        var parent = node.offsetParent;
        if (node && parent) {
            var rect = node.getBoundingClientRect();
            var parentRect = parent.getBoundingClientRect();
            this.setState({
                menuLeft: rect.left - parentRect.left
            });
        }
    },

    openMenu: function openMenu(e) {
        this.setState({ menuOpen: true });
    },

    setStateMousedOverDropDownMenuTrue: function setStateMousedOverDropDownMenuTrue() {
        this.setState({ mousedOverDropDownMenu: true });
    },

    setStateMousedOverDropDownMenuFalse: function setStateMousedOverDropDownMenuFalse() {
        this.setState({ mousedOverDropDownMenu: false });
    },

    closeMenu: function closeMenu() {
        this.setState({ menuOpen: false });
        var self = this;
        window.setTimeout(function () {
            if (self.state.mousedOverDropDownMenu !== true) {
                self.setState({ menuOpen: false });
            }
        }, 200);
    },

    render: function render() {

        var cx = _classnames2['default'];
        var rowClasses = {
            'm-link-list--link--container': true,
            'm-link-list--link-break-1': false
        };
        var linkClasses = {
            'm-link-list--link': true
        };
        var linkDefaultColors = {
            'c-white': this.props.useWhite ? true : false,
            'hc-warm-chinchilla': this.props.useWhite ? true : false,
            'hc-cerulean': this.props.useWhite ? false : true,
            'c-ashen': this.props.useWhite ? false : true
        };

        var linkColors = this.props.linkOverrideColors ? this.props.linkOverrideColors : linkDefaultColors;

        if (this.props.linkOptions && this.props.linkOptions.hasOwnProperty('class')) {
            var newProperty = {};
            var newPropertyKey = this.props.linkOptions['class'];
            newProperty[newPropertyKey] = true;
            linkClasses = _hfReactHelper2['default'].extend(newProperty, linkClasses);
        }

        if (this.props.linkUrl == this.props.pageToHighLight) {
            linkClasses = _hfReactHelper2['default'].extend({
                'm-link-list--currentPage': true
            }, linkClasses);
        }

        if (this.props.linkOptions && this.props.linkOptions.hasOwnProperty('colors')) {
            var propertyColorOverride = {};
            var propertyColorOverrideKey = this.props.linkOptions.colors;
            propertyColorOverride[propertyColorOverrideKey] = true;
            linkClasses = _hfReactHelper2['default'].extend(propertyColorOverride, linkClasses);
        } else {
            linkClasses = _hfReactHelper2['default'].extend(linkColors, linkClasses);
        }

        if (this.props.linkOptions && this.props.linkOptions.hasOwnProperty('container_class')) {
            var containerClasses = this.props.linkOptions.container_class.split(" ");
            for (var i = 0; i < containerClasses.length; i++) {
                var clazz = containerClasses[i];
                rowClasses[clazz] = true;
            }
        }

        // Stringify classes
        linkClasses = cx(linkClasses);
        rowClasses = cx(rowClasses);

        var dropDownMenu;
        if (this.props.linkOptions.hasOwnProperty('sub_menu_items') && this.state.menuOpen) {

            var style;
            if (this.props.linkOptions.hasOwnProperty('sub_menu_lock_to_parent') && this.props.linkOptions.sub_menu_lock_to_parent) {
                style = {};
                style.left = this.state.menuLeft ? this.state.menuLeft + 15 : 0;
                style.transform = "translateX(-30%)";
            } else {
                style = { right: 40 }; // Default, right side menu
            }

            dropDownMenu = _jsx('div', {
                onMouseEnter: this.setStateMousedOverDropDownMenuTrue,
                onMouseLeave: this.setStateMousedOverDropDownMenuFalse
            }, void 0, _react2['default'].createElement(_dropDownMenu2['default'], {
                id: this.props.linkOptions.sub_menu_id,
                ref: 'dropDownMenu',
                style: style,
                dropDownMenuLinkData: this.props.linkOptions.sub_menu_items,
                className: this.props.linkOptions.sub_menu_class }));
        }

        var dropDownArrow;
        if (this.props.linkOptions.hasOwnProperty('show_menu_drop_down_arrow') && this.props.linkOptions.show_menu_drop_down_arrow) {
            dropDownArrow = _jsx('span', {
                'class': 'm-drop-down-menu--drop-down-arrow'
            }, void 0, '▾');
        }

        return _jsx('div', {
            className: rowClasses,
            onMouseEnter: this.openMenu,
            onMouseLeave: this.closeMenu
        }, void 0, _jsx('a', {
            className: linkClasses,
            href: this.props.linkUrl,
            target: this.props.linkOptions.target,
            tabIndex: '-1'
        }, void 0, this.props.linkText, dropDownArrow), dropDownMenu);
    }
});

module.exports = TopBarMenuLink;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/home/top-bar-menu/top-bar-menu-link.jsx
 ** module id = 768
 ** module chunks = 0
 **/